import React from 'react';
import Nav from '../components/Nav/Nav';
import Main from '../components/Main/Main';
import './SurpriseMe.css';

const SurpriseMe = () => (
  <div className="surprise-main">
    <Nav />
    <Main />
  </div>
);

export default SurpriseMe;
